import { GatewayApi } from "./base";


class RequestImpl {
    constructor(
        readonly id?: string,
        readonly url?: string,
        readonly body?: string,
        readonly submitted_by?: string,
        readonly created_at?: string,
        readonly is_approved?: boolean,
        readonly approved_by?: string
    ) {}
}

export interface Request extends RequestImpl {}

export type RequestField = keyof Request;
export type RequestSorting = {field: RequestField, operator: string} | undefined;


export class RequestsApi extends GatewayApi {
    constructor() {
        super('requests');
    }

    async submit(actionUrl: string, body: object={}): Promise<boolean> {
        return this.submit_request(actionUrl, body);
    }

    async cancel(id: string): Promise<boolean> {
        const json: { result?: boolean } = await this.invoke('cancel', { id });
        return json.result ?? false;
    }

    async reject(id: string, rejected_by: string): Promise<boolean> {
        const json: { result?: boolean } = await this.invoke('reject', { id, rejected_by });
        return json.result ?? false;
    }

    async index(submitted_by?: string, sort?: RequestSorting): Promise<Request[]> {
        return await this.invoke('index', { submitted_by, sort }) ?? [];
    }

    async approve(id: string, approved_by: string): Promise<boolean> {
        const json: { result?: boolean } = await this.invoke('approve', { id, approved_by });
        return json.result ?? false;
    }
}
